import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";

import MovieCardSkeleton from "@/components/cards/MovieCard/MovieCard.skeleton";
import MoviesGrid from "@/components/helpers/MoviesGrid";
import { IconSadFace } from "@/components/icons";

import { useGetPremiers } from "@/hooks/api/content.hooks";

const PremierePage = () => {
  const { t } = useTranslation();

  const { ref: inViewRef, inView } = useInView();

  const { data, fetchNextPage, hasNextPage, isFetching } = useGetPremiers(48);
  const flattenedData = data?.pages.flatMap((page) => page.results) || [];

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage, isFetching]);
  return (
    <section className={"rounded-7.5 py-10 max-lg:rounded-5 max-lg:py-6"}>
      <div
        className={"flex items-center justify-between max-md:w-full max-md:flex-col max-md:items-stretch max-md:gap-6"}
      >
        <h1 className={"text-4xl font-semibold max-md:text-3xl/10"}>{t("premiere", { count: 5 })}</h1>
      </div>
      <section className={"rounded-7.5 max-lg:py-0"}>
        {flattenedData && flattenedData.length ? (
          <MoviesGrid content={flattenedData} />
        ) : !isFetching ? (
          <div className={"flex flex-col items-center"}>
            <IconSadFace />
            <div className={"mt-4 max-w-[27.5rem] text-center"}>
              <h1 className={"text-2xl font-semibold"}>{t("error.nothing-found")}</h1>
              <p className={"mt-2 text-lg/6 text-on-surface"}>{t("error.nothing-found-message")}</p>
            </div>
          </div>
        ) : null}
        {isFetching ? (
          <div className={"movies-grid mt-[16px]"}>
            {[...Array(24).keys()].map((_, index) => (
              <MovieCardSkeleton key={index} />
            ))}
          </div>
        ) : null}
        {flattenedData.length ? <div ref={inViewRef} className={"h-px w-full"} /> : null}
      </section>
    </section>
  );
};

export default PremierePage;
